import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RichEditor from "./RichEditor";

export default function EditorRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="rich-editor" replace />} />
      <Route path="rich-editor" element={<RichEditor />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
